import { createContext, useContext } from 'react';

type LayoutContextValue = {
  readonly inPage: boolean;
  readonly inShell: boolean;
};

const LayoutContext = createContext<LayoutContextValue>({ inPage: false, inShell: false });

const useLayoutContext = () => useContext(LayoutContext);

export { LayoutContext, useLayoutContext };
export type { LayoutContextValue };
